import { inject, InjectionKey, provide } from 'vue'

export type OverrideReportStatusOpenPayload = {
    reportId: number
    reportName: string
    reportType: number
    status: number
}

export type OverrideReportStatusModalActions = {
    openOverride: (payload: OverrideReportStatusOpenPayload) => void
}

export const OverrideReportStatusModalInjectionKey: InjectionKey<OverrideReportStatusModalActions> = Symbol(
    'OverrideReportStatusModalInjectionKey',
)

export const useOverrideReportStatusModal = () => {
    return inject(OverrideReportStatusModalInjectionKey)
}

export const provideOverrideReportStatusModal = (actions: OverrideReportStatusModalActions) =>
    provide(OverrideReportStatusModalInjectionKey, actions)
